import {
  MarketAccessReadOnly,
  MarketAccessSupported,
  MarketAccessVisiting,
  type MarketAccess,
} from '@/lib/api/apiTypes';

export function isReadOnlyMarketAccess(access?: MarketAccess | null) {
  return access === MarketAccessReadOnly;
}

export function isWritableMarketAccess(access?: MarketAccess | null) {
  return access === MarketAccessSupported || access === MarketAccessVisiting;
}
